<meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>

<template>
  <div style="display: grid; place-items: center; background-color: #DDDFE3; height:100%;width:100%;">
    <div class="knxScenarioContainer">
      <h1>SUITCASE SCENARIO</h1>
      <div class="suitcaseContainer">
        <div class="liveview">
          <div class="liveContainer">

            
            <iframe width="100%" height="100%" src="https://www.youtube.com/embed/BuhIRnoWRw4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
          </div>
        </div>
        <div class="switchesContainer">
          <div class="switchContainer">

            <img src="../../assets/scenarios/Switch1.png" alt="Desert">
            <label class="switchLabel">SWITCH 1</label>
            <label class="switch">
              <input type="checkbox" v-model="switch1" @change="toggleSwitch1">
              <span class="slider round"></span>
            </label>


          </div>
          <div class="switchContainer">
            <img src="../../assets/scenarios/Switch2.png" alt="Desert">
            <label class="switchLabel">SWITCH 2</label>
            <label class="switch">
              <input type="checkbox" v-model="switch2" @change="toggleSwitch2">
              <span class="slider round"></span>
            </label>
          </div>
          <div class="switchContainer">
            <img src="../../assets/scenarios/FireswitchRec.png" alt="Desert">
            <label class="switchLabel">FIRE SWITCH</label>
            <label class="switch">
              <input type="checkbox" v-model="fireSwitch" @change="toggleFireSwitch">
              <span class="slider round"></span>
            </label>

          </div>
          <div class="switchContainer">
            <img src="../../assets/scenarios/WaterSwitch.png" alt="Desert">
            <label class="switchLabel">WATER SWITCH</label>
            <label class="switch">
              <input type="checkbox" v-model="waterSwitch" @change="toggleWaterSwitch">
              <span class="slider round"></span>
            </label>
          </div>

        </div>

        <div class="slidersContainer">
          <div class="sliderContainer">
            <input class="dimmerSlider" type="range" min="0" max="100" v-model="dimmer1" @change="toggleDimmer1">
            <label class="sliderLabel">DIMMER 1: {{ dimmer1 }}</label>
          </div>
          <div class="sliderContainer">
            <input class="dimmerSlider" type="range" min="0" max="100" v-model="dimmer2" @change="toggleDimmer2">
            <label class="sliderLabel">DIMMER 2: {{ dimmer2 }}</label>
          </div>

        </div>
      </div>

    </div>


  </div>
</template>
//Hay que cambiar los paths del core por los de digital dice
<script>
import $ from 'jquery';
import suitcaseDDAPI from '../../services/suitcaseDDAPI';
//var switch1sse = this.$sse.create({ url: 'https://acgsaas.ual.es/things/acg:lab:suitcase-dd/status/sse' })


export default {
  sse: {
    cleanup: true
  },
  data() {
    return {
      switch1: false,
      switch2: false,
      fireSwitch: false,
      waterSwitch: false,
      dimmer1: 0,
      dimmer2: 0,
      eventSource: null 
    }
  },
  computed: {
    compSwitch1: {
      get() {
        return this.switch1;
      },
      set(val) {
        this.switch1 = val;
      }
    },
    compSwitch2: {
      get() {
        return this.switch2;
      },
      set(val) {
        this.switch2 = val;
      }
    },
    compFireSwitch: {
      get() {
        return this.fireSwitch;
      },
      set(val) {
        this.fireSwitch = val;
      }
    },
    compWaterSwitch: {
      get() {
        return this.waterSwitch;
      },
      set(val) {
        this.waterSwitch = val;
      }
    },
    compDimmer1: {
      get() {
        return this.dimmer1;
      },
      set(val) {
        this.dimmer1 = val;
      }
    },
    compDimmer2: {
      get() {
        return this.dimmer2;
      },
      set(val) {
        this.dimmer2 = val;
      }
    },
  },
  watch: {
    // async switch1(val) {
    //   console.log("Watch switch1:" + val);
    //   //await this.toggleSwitch1(val);
    // },
    // async switch2(val) {
    //   await this.toggleSwitch2(val);
    // },
    // async fireSwitch(val) {
    //   await this.toggleFireSwitch(val);
    // },
    // async waterSwitch(val) {
    //   await this.toggleWaterSwitch(val);
    // },
    // async dimmer1(val) {
    //   await this.toggleDimmer1(val);
    // },
    // async dimmer2(val) {
    //   await this.toggleDimmer2(val);
    // },
  },
  async beforeMount() {
    //Obtener los valores del Core para inicializar el escenario
    //Long polling a los valores del Core
    this.eventSource = new EventSource('https://acgsaas.ual.es/things/acg:lab:suitcase-dd/status/sse');
    this.eventSource.addEventListener('message', event => { 
      let doc = JSON.parse(event.data);
        console.log('Switch 1: ' + doc.interaction);
        switch (doc.interaction) {
          case 'property.status-light1':
            this.switch1 = doc.data.value;
            break;
          case 'property.status-light2':
            this.switch2 = doc.data.value;
            break;
          case 'property.status-fire':
            this.fireSwitch = doc.data.value;
            break;
          case 'property.status-water':
            this.waterSwitch = doc.data.value;
            break;
          case 'property.luminosity-dimmer1':
            this.dimmer1 = doc.data.brightness;
            break;
          case 'property.luminosity-dimmer2':
            this.dimmer2 = doc.data.brightness;
            break;
        }
    });

    this.getSwitch1Status();
    this.getSwitch2Status();
    this.getFireSwitchStatus();
    this.getWaterSwitchStatus();
    this.getDimmer1Brightness();
    this.getDimmer2Brightness();


  },
  beforeDestroy() {
    this.eventSource.close();    
  },
  methods: {
    //Funciones para actualizar los valores del Core
    async getSwitch1Status() {
      suitcaseDDAPI.get('/property/status-light1/').then((response) => {
        this.switch1 = response.data.value;
      })
    },
    async getSwitch2Status() {
      suitcaseDDAPI.get('/property/status-light2/').then((response) => {
        this.switch2 = response.data.value;
      })

    },
    async getFireSwitchStatus() {
      suitcaseDDAPI.get('/property/status-fire/').then((response) => {
        this.fireSwitch = response.data.value;
      })

    },
    async getWaterSwitchStatus() {
      suitcaseDDAPI.get('/property/status-water/').then((response) => {
        this.waterSwitch = response.data.value;
      })

    },
    async getDimmer1Brightness() {
      suitcaseDDAPI.get('/property/luminosity-dimmer1/').then((response) => {
        this.dimmer1 = response.data.brightness;
      })

    },
    async getDimmer2Brightness() {
      suitcaseDDAPI.get('/property/luminosity-dimmer2/').then((response) => {
        this.dimmer2 = response.data.brightness;
      })
    },
    async toggleSwitch1(event) {
      console.log("BUENAS TARDES: ", event.target.checked);
      suitcaseDDAPI.post('/action/switch-light1/', { value: event.target.checked })
    },
    async toggleSwitch2(event) {
      console.log("BUENAS TARDES: ", event.target.checked);
      suitcaseDDAPI.post('/action/switch-light2/', { value: event.target.checked })
    },
    async toggleFireSwitch(event) {
      console.log("BUENAS TARDES: ", event.target.checked);
      suitcaseDDAPI.post('/action/switch-fire/', { value: event.target.checked })
    },
    async toggleWaterSwitch(event) {
      console.log("BUENAS TARDES: ", event.target.checked);
      suitcaseDDAPI.post('/action/switch-water/', { value: event.target.checked })
    },
    async toggleDimmer1(event) {
      console.log("BUENAS TARDES: ", event.target.value);
      suitcaseDDAPI.post('/action/switch-dimmer1/', { brightness: event.target.value })
    },
    async toggleDimmer2(event) {
      console.log("BUENAS TARDES: ", event.target.value);
      suitcaseDDAPI.post('/action/switch-dimmer2/', { brightness: event.target.value })
    }
  }
}


</script>

<style lang="scss">
.suitcaseContainer {
  display: grid;
  grid-template-areas: "liveview liveview"
    "switchesContainer slidersContainer";
  height: 100%;
  width: 100%;
  max-width: 1150px;
  /*place-items: center;*/
  gap: 10px;
  
}

.dimmerSlider {
  -webkit-appearance: none;
  width: 100%;
  height: 15px;
  border-radius: 12px;
  background: #d3d3d3;
  outline: none;
  opacity: 0.7;
  -webkit-transition: .2s;
  transition: opacity .2s;
}

.dimmerSlider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #444;
  cursor: pointer;
}

.dimmerSlider::-moz-range-thumb {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #444;
  cursor: pointer;
}

.knxScenarioContainer {
  display: grid;
  place-items: center;
  background-color: #F6F6F6;
  border-radius: 12px;
  padding: 1rem 5rem 5rem 5rem;
  margin: 1rem 0;
  border: 1px solid #AAA;
}

.sliderContainer {
  margin: 1rem;
  display: flex;
  float: right;
  align-items: center;
  gap: 10px;
}

.switchesContainer {
  grid-area: switchesContainer;
  padding: 10px;
  display: grid;
  grid-template-columns: repeat(2, minmax(200px, 1fr));
  width: 100%;
  place-items: start;
}

.switchContainer {
  display: grid;
  grid-template-rows: 0.4fr 0.4fr 1fr;
  min-height: 160px;
  gap: 0px;
  place-items: center;
}

.liveview {
  grid-area: liveview;
  margin-top: 1rem;
  margin-right: 1rem;
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
}

.liveContainer {
  width: 550px;
  height: 350px;
  display: grid;
  place-items: center;
}

.slidersContainer {
  grid-area: slidersContainer;
  display: grid;
  place-items: center;
  margin-top: 2rem;
}

.sliderLabel {
  font-size: 16px;
  font-weight: bold;
  width: 7rem;
}

.switchLabel {
  font-size: 16px;
  font-weight: bold;
}


/* The switch - the box around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 120px;
  height: 68px;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* The slider */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(46, 48, 56, 0.5);
  ;
  -webkit-transition: .4s;
  transition: .4s;
  text-align: center;

}

.slider:before {
  position: absolute;
  content: "OFF";
  padding-top: 12%;
  height: 56px;
  width: 56px;
  left: 6px;
  bottom: 6px;
  background-color: #DF6451;
  font-weight: 700;
  color: white;
  -webkit-transition: .4s;
  transition: .4s;
}


input:checked+.slider:before {
  -webkit-transform: translateX(52px);
  -ms-transform: translateX(52px);
  transform: translateX(52px);
  content: "ON";
  background-color: #35BC7A;
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

/* The brightness sliders */
svg {
  width: 150%;
  height:150%;
  visibility: hidden;
}

.upText,
.downText {
  text-anchor: middle;
  font-weight: 700;
  font-size: 14px;
  fill: #000;
  letter-spacing: 0.4px;
  user-select: none;
  -webkit-user-select: none;
  pointer-events: none;
  text-rendering: optimizeSpeed;
}

.upText {
  font-size: 24px;
}

#dragger{
-webkit-tap-highlight-color: rgba(0,0,0,0); 
}

.downText {
  letter-spacing: -0.4px;
}

::-webkit-scrollbar {
  width: 0px;
}</style>

